import { selectCurrentDialog } from '@ui/features/quote-builder/state/selectors/current-dialog';
import { useDispatch } from '@ui/hooks/useDispatch';
import { useSelector } from '@ui/hooks/useSelector';

import { actions } from '../state/reducer';
import { QuoteBuilderDialogType } from '../types/state/internal';

type UseQuoteBuilderDialogReturn = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
};

export function useQuoteBuilderDialog(
  params: QuoteBuilderDialogType,
): UseQuoteBuilderDialogReturn {
  const currentDialog = useSelector(selectCurrentDialog);
  const dispatch = useDispatch();

  const isOpen =
    currentDialog?.name === params.name &&
    currentDialog?.quoteLineUuid === params.quoteLineUuid;

  function open() {
    dispatch(actions.dialogOpened(params));
  }

  function close() {
    dispatch(actions.dialogClosed());
  }

  return {
    isOpen,
    open,
    close,
  };
}
